
import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const baseLink =
    "text-sm text-ink-muted hover:text-[var(--brand-1)] transition-colors";

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 16);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const doScroll = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(doScroll, 80);
    } else {
      doScroll();
    }

    setMobileOpen(false);
    setServicesOpen(false);
  };

  const scrollToId = (id) => {
    const navOffset = 80;

    const doScroll = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - navOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(doScroll, 80);
    } else {
      doScroll();
    }

    setMobileOpen(false);
    setServicesOpen(false);
  };

  return (
    <header className="sticky top-0 z-50">
      <div
        className={`bg-transparent transition-all duration-300 ${
          scrolled ? "py-1" : "py-3"
        }`}
      >
        <div className="mx-auto max-w-7xl px-4">
          <div
            className={`flex items-center justify-between border border-slate-200/70 bg-white/80 backdrop-blur-xl transition-all duration-300 shadow-[0_18px_45px_rgba(15,23,42,0.08)] pointer-events-auto
            ${scrolled ? "rounded-2xl h-12" : "rounded-3xl h-14"}`}
          >
            <button
              type="button"
              onClick={scrollToTop}
              className="ml-4 font-semibold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[var(--brand-1)] to-[var(--brand-4)]"
            >
              Zentra Group
            </button>

            <nav className="hidden md:flex items-center gap-8">
              <button
                type="button"
                onClick={() => scrollToId("nosotros")}
                className={baseLink}
              >
                Nosotros
              </button>

              <div
                className="relative"
                onMouseEnter={() => setServicesOpen(true)}
              >
                <button
                  type="button"
                  onClick={() => setServicesOpen((x) => !x)}
                  className={`${baseLink} inline-flex items-center gap-1`}
                >
                  Servicios
                  <svg
                    viewBox="0 0 20 20"
                    className={`h-4 w-4 transition-transform ${
                      servicesOpen ? "rotate-180" : ""
                    }`}
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>

                {servicesOpen && (
                  <div
                    className="absolute left-0 mt-3 w-56 rounded-2xl border border-slate-200 bg-white shadow-[0_18px_40px_rgba(15,23,42,0.12)] py-2 z-50"
                    onMouseLeave={() => setServicesOpen(false)}
                  >
                    <button
                      type="button"
                      onClick={() => scrollToId("servicios")}
                      className="block w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
                    >
                      Detalle general
                    </button>
                    <button
                      type="button"
                      onClick={() => scrollToId("pricing")}
                      className="block w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
                    >
                      Zentra GPS
                    </button>
                    <button
                      type="button"
                      onClick={() => scrollToId("servicios")}
                      className="block w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
                    >
                      Zentra Sistemas
                    </button>
                  </div>
                )}
              </div>

              <button
                type="button"
                onClick={() => scrollToId("dudas")}
                className={baseLink}
              >
                Dudas Frecuentes
              </button>
            </nav>

{/* ---- CLIENTE (DESKTOP) ---- */}
<div className="hidden md:flex items-center gap-3 mr-4">
  <NavLink
    to="/cliente"
    className={({ isActive }) =>
      `text-sm px-4 py-2 rounded-full btn-brand shadow-sm transition ${
        isActive ? "ring-2 ring-[var(--brand-3)]" : "hover:brightness-110"
      }`
    }
    onClick={() => {
      setMobileOpen(false);
      setServicesOpen(false);
    }}
  >
    Cliente
  </NavLink>
</div>


            <button
              type="button"
              className="md:hidden inline-flex flex-col items-center justify-center rounded-md p-2 mr-3 bg-transparent hover:bg-slate-100 transition-colors"
              onClick={() => setMobileOpen((prev) => !prev)}
              aria-label="Abrir menú de navegación"
              aria-expanded={mobileOpen}
            >
              <span
                className={`block h-[2px] w-6 rounded-full bg-[var(--brand-1)] transition-transform duration-200 ${
                  mobileOpen ? "translate-y-[5px] rotate-45" : ""
                }`}
              />
              <span
                className={`block h-[2px] w-6 rounded-full bg-[var(--brand-3)] my-[3px] transition-opacity duration-200 ${
                  mobileOpen ? "opacity-0" : "opacity-100"
                }`}
              />
              <span
                className={`block h-[2px] w-6 rounded-full bg-[var(--brand-4)] transition-transform duration-200 ${
                  mobileOpen ? "-translate-y-[5px] -rotate-45" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Menú móvil */}
      {mobileOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white/95 backdrop-blur">
          <nav className="mx-auto max-w-7xl px-4 py-3 flex flex-col gap-3">
            <button
              type="button"
              onClick={() => scrollToId("nosotros")}
              className={baseLink}
            >
              Nosotros
            </button>

            <div className="border-t border-slate-100 pt-3 mt-1">
              <p className="text-xs font-semibold text-slate-500 mb-1">
                Servicios
              </p>
              <button
                type="button"
                onClick={() => scrollToId("servicios")}
                className={`${baseLink} block text-left`}
              >
                Detalle general
              </button>
              <button
                type="button"
                onClick={() => scrollToId("pricing")}
                className={`${baseLink} block text-left`}
              >
                Zentra GPS
              </button>
              <button
                type="button"
                onClick={() => scrollToId("servicios")}
                className={`${baseLink} block text-left`}
              >
                Zentra Sistemas
              </button>
            </div>

            <button
              type="button"
              onClick={() => scrollToId("dudas")}
              className={baseLink}
            >
              Dudas Frecuentes
            </button>

            {/* ---- CLIENTE DESHABILITADO (MÓVIL) ---- */}
            <div className="mt-3 flex flex-col gap-2 border-t border-slate-100 pt-3">
              <NavLink
                to="/cliente"
                className={({ isActive }) =>
                  `text-sm px-4 py-2 rounded-xl btn-brand shadow-sm text-center transition ${
                    isActive ? "ring-2 ring-[var(--brand-3)]" : "hover:brightness-110"
                  }`
                }
                onClick={() => {
                  setMobileOpen(false);
                  setServicesOpen(false);
                }}
              >
                Cliente
              </NavLink>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
